import { Inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { Usuario } from '../models/usuario';
import { STORAGE_KEYS } from './storage_keys.config';
import { Empresa } from '../models/empresa';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private window: Window;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.window = document.defaultView;
  }

  getLocalUser(): Usuario {
    const usr = this.getItem(STORAGE_KEYS.localUser);
    if (usr == null) {
      return new Usuario();
    } else {
      return Object.assign(new Usuario(), JSON.parse(usr));
    }
  }

  setLocalUser(obj: Usuario) {
    if (obj == null) {
      this.cleanLocalStorageUser();
    } else {
      this.setItem(STORAGE_KEYS.localUser, JSON.stringify(obj));
    }
  }

  getLocalFilterLead(): any {
    let filter = localStorage.getItem(STORAGE_KEYS.localFilterLead);

    return JSON.parse(filter);
  }

  setLocalFilterLead(filter: object) {
    localStorage.setItem(STORAGE_KEYS.localFilterLead, JSON.stringify(filter));
  }

  cleanLocalFilterLead(): void {
    localStorage.removeItem(STORAGE_KEYS.localFilterLead);
  }

  getLocalToken(): string {
    let token = this.getItem(STORAGE_KEYS.localToken);

    return token;
  }

  setLocalToken(token: string) {
    this.setItem(STORAGE_KEYS.localToken, token);
  }

  getLocalEmpresa(): Empresa {
    let usr = this.getItem(STORAGE_KEYS.localEmpresa);
    if (usr == null) {
      return null;
    } else {
      return JSON.parse(usr);
    }
  }

  setLocalEmpresa(obj: Empresa) {
    if (obj == null) {
      this.cleanLocalStorageEmpresa();
    } else {
      this.setItem(STORAGE_KEYS.localEmpresa, JSON.stringify(obj));
    }
  }

  cleanLocalStorageUser(): void {
    this.setItem(STORAGE_KEYS.localUser, '');
    this.removeItem(STORAGE_KEYS.localUser);
  }

  cleanLocalStorageEmpresa(): void {
    this.setItem(STORAGE_KEYS.localEmpresa, '');
    this.removeItem(STORAGE_KEYS.localEmpresa);
  }

  cleanLocalStorageToken(): void {
    this.setItem(STORAGE_KEYS.localToken, '');
    this.removeItem(STORAGE_KEYS.localToken);
  }

  clean() {
    this.cleanLocalStorageUser();
    this.cleanLocalStorageToken();
    this.cleanLocalStorageEmpresa();
  }

  private setItem(key: string, value: string): void {
    if (isPlatformServer(this.platformId)) return;

    this.window.localStorage.setItem(key, value);
  }

  private getItem(key: string): string {
    if (isPlatformServer(this.platformId)) return null;

    return this.window.localStorage.getItem(key);
  }

  private removeItem(key: string): void {
    if (isPlatformServer(this.platformId)) return;

    return this.window.localStorage.removeItem(key);
  }
}
